<template>
  <b-modal
    id="subscription-plan-details"
    ref="planDetailsModal"
    hide-footer
    :title="plan.name + ' Details'"
    @shown="fetchDetails"
  >
    <b-list-group>
      <b-list-group-item><strong>Description:</strong> {{ plan.description }}</b-list-group-item>
      <b-list-group-item><strong>Price:</strong> {{ plan.price }}</b-list-group-item>
      <b-list-group-item><strong>Zone:</strong> {{ plan.zone ? plan.zone : 'Not specified' }}</b-list-group-item>
      <b-list-group-item><strong>Country:</strong> {{ plan.country }}</b-list-group-item>
      <b-list-group-item><strong>Target:</strong> {{ plan.target }}</b-list-group-item>
      <b-list-group-item><strong>Billing Cycle (days):</strong> {{ plan.billing_cycle_days }}</b-list-group-item>
      <b-list-group-item v-if="plan.features && plan.features.benefits && plan.features.benefits.length">
        <strong>Benefits:</strong>
        <ul class="list-unstyled mt-2">
          <li
            v-for="(item, index) in plan.features.benefits"
            :key="index"
          >
            <strong>Name: {{ item.name }}</strong> — Description: {{ item.description }}<br>
            <small>Note: {{ item.note }}</small>
          </li>
        </ul>
      </b-list-group-item>
      <b-list-group-item><strong>Active:</strong> {{ plan.is_active ? 'Yes' : 'No' }}</b-list-group-item>
      <b-list-group-item><strong>Created At:</strong> {{ new Date(plan.created_at).toLocaleString() }}</b-list-group-item>
    </b-list-group>
  </b-modal>
</template>

<script>
import { BListGroupItem, BListGroup } from 'bootstrap-vue'

export default {
  components: {
    BListGroupItem, BListGroup,
  },
  props: {
    plan: {
      type: Object,
      required: true,
    },
  },
}
</script>
